// extracted by mini-css-extract-plugin
export default {"alertIconContent":"ExternalPartScreen_alertIconContent__QHBxX","form":"ExternalPartScreen_form__qMsxD","tabContainer":"ExternalPartScreen_tabContainer__fcVcC"};